<template>
  <div class="mt-2" v-if="isShowCheckBoxSlideNote">
    <p class="font-normal opacity-80 text-sm">
      This presentation contains slide notes
      <i
        class="fas fa-question-circle text-secondary-20 cursor-pointer"
        v-tooltip="'See the presenter’s slide notes when you edit this presentation'"
      ></i>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    isShowCheckBoxSlideNote() {
      return this.presentation.slides.filter((item) => item.notes).length &&
        this.presentation.enableCopySlideNote
    },
  },
}
</script>
